
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/aapningsdato-for-skianlegg",
      function () {
        return require("private-next-pages/[region]/aapningsdato-for-skianlegg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/aapningsdato-for-skianlegg"])
      });
    }
  